// src/sections/FreePilotSignup.jsx
import { useState } from "react";
import { motion } from "framer-motion";
import { freePilotSignup, siteMeta } from "../data/siteContent";
import SectionIntro from "../components/motion/SectionIntro";
import { fadeUp, viewportOnce } from "../utils/motion";

export default function FreePilotSignup() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    fleetSize: "",
    message: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    
    // Open WhatsApp with the form data
    const whatsappMessage = `Hi Dryvziro, I'd like to start a free fuel pilot for my fleet.%0A%0AName: ${formData.name}%0APhone: ${formData.phone}%0AFleet Size: ${formData.fleetSize}%0AMessage: ${formData.message || "N/A"}`;
    window.open(`https://wa.me/254705247958?text=${whatsappMessage}`, "_blank");
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <section className="section-block section-block--light" id="pilot">
      <div className="container-shell">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          <SectionIntro
            eyebrow={freePilotSignup.eyebrow}
            title={freePilotSignup.title}
            description={freePilotSignup.subtitle}
            align="center"
          />
        </motion.div>

        <motion.div
          className="pilot-signup-grid"
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          <div className="pilot-signup__features">
            <ul>
              {freePilotSignup.features.map((feature, index) => (
                <li key={index}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M5 13L9 17L19 7"
                      stroke="#b4e920"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  {feature}
                </li>
              ))}
            </ul>
          </div>

          <div className="pilot-signup__form">
            {isSubmitted ? (
              <motion.div
                className="pilot-signup__success"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
              >
                <p>{freePilotSignup.form.successMessage}</p>
              </motion.div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">{freePilotSignup.form.name.label}</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder={freePilotSignup.form.name.placeholder}
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">{freePilotSignup.form.phone.label}</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    placeholder={freePilotSignup.form.phone.placeholder}
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="fleetSize">{freePilotSignup.form.fleetSize.label}</label>
                  <select
                    id="fleetSize"
                    name="fleetSize"
                    value={formData.fleetSize}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select fleet size</option>
                    {freePilotSignup.form.fleetSize.options.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">{freePilotSignup.form.message.label}</label>
                  <textarea
                    id="message"
                    name="message"
                    placeholder={freePilotSignup.form.message.placeholder}
                    value={formData.message}
                    onChange={handleChange}
                    rows={4}
                  />
                </div>

                <button type="submit" className="btn btn--primary">
                  {freePilotSignup.form.submitButton}
                </button>

                <p className="form-note">{freePilotSignup.form.note}</p>
              </form>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
